import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "factoids-page" };
const _hoisted_2 = { class: "factoids-content" };
const _hoisted_3 = { class: "cell-value" };
const _hoisted_4 = ["title"];
const _hoisted_5 = {
    key: 0,
    class: "test-loading"
};
const _hoisted_6 = {
    key: 1,
    class: "test-error"
};
const _hoisted_7 = {
    key: 2,
    class: "test-response"
};
const _hoisted_8 = { class: "response-preview" };
const _hoisted_9 = {
    key: 3,
    class: "test-empty"
};
import { ref, computed, nextTick, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
import AdminTable from '@/admin/components/AdminTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FactoidsPage',
    setup(__props) {
        const admin = useAdmin();
        const sourcesTable = ref(null);
        const factiodsTable = ref(null);
        const showValidationToast = ref(false);
        const validationMessage = ref('');
        const showTestDialog = ref(false);
        const testResponse = ref(null);
        const testLoading = ref(false);
        const testError = ref(null);
        const selectedSourceId = ref(null);
        const factoidSearch = ref('');
        const showDeleteSourceDialog = ref(false);
        const deleteSourceId = ref(null);
        const showDeleteFactoidDialog = ref(false);
        const deleteFactoidId = ref(null);
        const sourceColumns = ref([
            {
                field: 'pageUrl',
                label: 'Page URL',
                width: '2fr',
                sortable: false,
                editable: true,
                type: 'url',
                required: true,
                placeholder: 'https://example.com'
            },
            {
                field: 'acceptCookiesButton',
                label: 'Accept Cookies Button',
                width: '1.5fr',
                sortable: false,
                editable: true,
                type: 'text',
                required: false,
                placeholder: 'e.g., .cookie-accept'
            },
            {
                field: 'contentSelector',
                label: 'Content Selector',
                width: '1.5fr',
                sortable: false,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., .article-content'
            },
            {
                field: 'lastScanDateTime',
                label: 'Last Scan',
                width: '1fr',
                sortable: false,
                editable: false,
                type: 'date',
                addRowDefault: '—'
            }
        ]);
        const factoidColumns = ref([
            {
                field: 'name',
                label: 'Name',
                width: '2fr',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., Interest Rate'
            },
            {
                field: 'description',
                label: 'Description',
                width: '1.5fr',
                sortable: false,
                editable: true,
                type: 'textarea',
                required: false,
                placeholder: 'e.g., Current federal interest rate'
            },
            {
                field: 'value',
                label: 'Value',
                width: '1.5fr',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., 3.5%'
            },
            {
                field: 'source',
                label: 'Source',
                width: '1.5fr',
                sortable: true,
                editable: false,
                type: 'text',
                addRowDefault: 'manual'
            },
            {
                field: 'createdDateTime',
                label: 'Created',
                width: '1.5fr',
                sortable: true,
                editable: false,
                type: 'date'
            }
        ]);
        const sources = computed(() => admin.adminState.sources);
        const sourcesLoading = computed(() => admin.adminState.sourcesLoading);
        const factoidLoading = computed(() => admin.adminState.factoidLoading);
        const filteredFactoids = computed(() => {
            let filtered = admin.adminState.factoids;
            if (selectedSourceId.value) {
                const selectedSource = sources.value.find((s) => s.id === selectedSourceId.value);
                if (selectedSource) {
                    filtered = filtered.filter((factoid) => factoid.source === selectedSource.pageUrl);
                }
            }
            return filtered;
        });
        function selectSource(row) {
            selectedSourceId.value = selectedSourceId.value === row.id ? null : row.id;
            if (selectedSourceId.value) {
                nextTick(() => {
                    factiodsTable.value?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }
        }
        function handleSourceEditSave({ rowId, data }) {
            if (!data.pageUrl || !data.contentSelector) {
                const missing = [];
                if (!data.pageUrl)
                    missing.push('Page URL');
                if (!data.contentSelector)
                    missing.push('Content Selector');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            admin.updateSource(rowId, {
                pageUrl: data.pageUrl,
                acceptCookiesButton: data.acceptCookiesButton || '',
                contentSelector: data.contentSelector
            }, () => {
                sourcesTable.value?.cancelEdit();
            });
        }
        function handleSourceDelete(row) {
            deleteSourceId.value = row.id;
            showDeleteSourceDialog.value = true;
        }
        function confirmDeleteSource() {
            admin.deleteSource(deleteSourceId.value);
            showDeleteSourceDialog.value = false;
            deleteSourceId.value = null;
        }
        function cancelDeleteSource() {
            showDeleteSourceDialog.value = false;
            deleteSourceId.value = null;
        }
        function handleSourceAdd(data) {
            if (!data.pageUrl || !data.contentSelector) {
                const missing = [];
                if (!data.pageUrl)
                    missing.push('Page URL');
                if (!data.contentSelector)
                    missing.push('Content Selector');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            admin.createSource({
                pageUrl: data.pageUrl,
                acceptCookiesButton: data.acceptCookiesButton || '',
                contentSelector: data.contentSelector
            });
        }
        function testExistingSource(source) {
            showTestDialog.value = true;
            testLoading.value = true;
            testError.value = null;
            testResponse.value = null;
            admin.testSource({
                pageUrl: source.pageUrl,
                acceptCookiesButton: source.acceptCookiesButton || '',
                contentSelector: source.contentSelector
            }, (response) => {
                testResponse.value = response;
                testLoading.value = false;
            }, (error) => {
                testError.value = error;
                testLoading.value = false;
            });
        }
        function handleFactoidDelete(row) {
            deleteFactoidId.value = row.id;
            showDeleteFactoidDialog.value = true;
        }
        function confirmDeleteFactoid() {
            admin.deleteFactoid(deleteFactoidId.value);
            showDeleteFactoidDialog.value = false;
            deleteFactoidId.value = null;
        }
        function cancelDeleteFactoid() {
            showDeleteFactoidDialog.value = false;
            deleteFactoidId.value = null;
        }
        function handleFactoidAdd(data) {
            if (!data.name || !data.value) {
                const missing = [];
                if (!data.name)
                    missing.push('Name');
                if (!data.value)
                    missing.push('Value');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            admin.createFactoid({
                name: data.name,
                value: data.value,
                description: data.description || '',
                source: 'manual'
            });
        }
        function handleFactoidSearchClear() {
            selectedSourceId.value = null;
            factoidSearch.value = '';
        }
        onMounted(() => {
            console.log('Factoids Page loaded');
            admin.getFactoids();
            admin.getSources();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(AdminTable, {
                            ref_key: "sourcesTable",
                            ref: sourcesTable,
                            title: "Sources",
                            icon: "📍",
                            columns: sourceColumns.value,
                            data: sources.value,
                            loading: sourcesLoading.value,
                            searchable: true,
                            "search-placeholder": "Search sources...",
                            collapsible: true,
                            "default-expanded": true,
                            editable: true,
                            selectable: true,
                            deletable: true,
                            addable: true,
                            "empty-message": "No sources configured. Add one below to start scraping factoids.",
                            onRowSelect: selectSource,
                            onRowEditSave: handleSourceEditSave,
                            onRowDelete: handleSourceDelete,
                            onRowAdd: handleSourceAdd
                        }, null, 8, ["columns", "data", "loading"]),
                        _createVNode(AdminTable, {
                            ref_key: "factiodsTable",
                            ref: factiodsTable,
                            title: "Factoids",
                            icon: "📍",
                            columns: factoidColumns.value,
                            data: filteredFactoids.value,
                            loading: factoidLoading.value,
                            searchable: true,
                            "search-placeholder": "Search factoids...",
                            "show-clear-button": !!selectedSourceId.value,
                            collapsible: true,
                            "default-expanded": true,
                            editable: false,
                            selectable: false,
                            deletable: true,
                            addable: true,
                            "empty-message": selectedSourceId.value ? 'No factoids found for this source.' : 'No factoids found. Start by creating a new factoid.',
                            badge: selectedSourceId.value || factoidSearch.value ? filteredFactoids.value.length + ' results' : null,
                            "external-search-query": factoidSearch.value,
                            onRowDelete: handleFactoidDelete,
                            onRowAdd: handleFactoidAdd,
                            onSearchUpdate: _cache[0] || (_cache[0] = ($event) => (factoidSearch.value = $event)),
                            onSearchClear: handleFactoidSearchClear
                        }, {
                            "cell-name": _withCtx(({ row }) => [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(row.name), 1)
                            ]),
                            "cell-source": _withCtx(({ value }) => [
                                _createElementVNode("span", {
                                    class: "cell-value",
                                    title: value || ''
                                }, _toDisplayString(value || '—'), 9, _hoisted_4)
                            ]),
                            _: 1
                        }, 8, ["columns", "data", "loading", "show-clear-button", "empty-message", "badge", "external-search-query"])
                    ])
                ]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showValidationToast.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showValidationToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showValidationToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(validationMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showTestDialog.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showTestDialog).value = $event)),
                    title: "Test Source Preview",
                    "max-width": "600px",
                    contentHeight: "400px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        (testLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[7] || (_cache[7] = [
                                _createElementVNode("p", null, "Loading page content...", -1)
                            ])))
                            : (testError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("p", null, [
                                        _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Error:", -1)),
                                        _createTextVNode(" " + _toDisplayString(testError.value), 1)
                                    ])
                                ]))
                                : (testResponse.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Page Content Preview:", -1)),
                                            _createElementVNode("pre", null, _toDisplayString(testResponse.value), 1)
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[10] || (_cache[10] = [
                                        _createElementVNode("p", null, "No response yet.", -1)
                                    ])))
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn primary",
                            onClick: _cache[3] || (_cache[3] = ($event) => (showTestDialog.value = false))
                        }, "Close")
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteSourceDialog.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showDeleteSourceDialog).value = $event)),
                    title: "Delete Source",
                    "max-width": "300px",
                    contentHeight: "150px",
                    persistent: true
                }, {
                    content: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("p", null, "Are you sure you want to delete this source? This action cannot be undone.", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteSource,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: cancelDeleteSource,
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteFactoidDialog.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showDeleteFactoidDialog).value = $event)),
                    title: "Delete Factoid",
                    "max-width": "300px",
                    contentHeight: "150px",
                    persistent: true
                }, {
                    content: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("p", null, "Are you sure you want to delete this factoid? This action cannot be undone.", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteFactoid,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: cancelDeleteFactoid,
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
